import { render, staticRenderFns } from "./WebhooksSettings.vue?vue&type=template&id=25302294&scoped=true"
import script from "./WebhooksSettings.vue?vue&type=script&lang=js"
export * from "./WebhooksSettings.vue?vue&type=script&lang=js"
import style0 from "./WebhooksSettings.vue?vue&type=style&index=0&id=25302294&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25302294",
  null
  
)

export default component.exports